import { zonedTimeToUtc } from 'date-fns-tz';
import { WeatherConstraintFromQueryString } from 'features/traceHistory/types';
import { WeatherConstraint } from '../types';

export const makeShareWeatherUrl = (
  protocol: string,
  host: string,
  fromDate: Date,
  toDate: Date,
  analyzerId: number,
  snapshotId: number,
  traceIndex: number,
  weatherConstraints: (WeatherConstraint | WeatherConstraintFromQueryString)[],
  timezone: string,
  forecast?: boolean,
  dishId?: number
) => {
  const urlString =
    `${protocol}//${host}` +
    makeShareWeatherUrlNoHost(
      fromDate,
      toDate,
      analyzerId,
      snapshotId,
      traceIndex,
      weatherConstraints,
      timezone,
      forecast,
      dishId
    );
  return urlString;
};

export const makeShareWeatherUrlNoHost = (
  fromDate: Date,
  toDate: Date,
  analyzerId: number,
  snapshotId: number,
  traceIndex: number,
  weatherConstraints: (WeatherConstraint | WeatherConstraintFromQueryString)[],
  timezone: string,
  forecast?: boolean,
  dishId?: number
) => {
  let urlString = forecast ? '/forecast-reflection' : '/reflection';
  urlString += forecast ? '?forecast=1' : '?weather=1';
  urlString += `&start=${zonedTimeToUtc(
    fromDate,
    timezone
  ).toISOString()}&end=${zonedTimeToUtc(
    toDate,
    timezone
  ).toISOString()}&analyzer=${analyzerId}&snapshot=${snapshotId}&trace=${traceIndex}`;
  if (forecast) urlString += `&dish=${dishId}`;
  let idx = 0;
  for (const value of weatherConstraints) {
    if (Number(value.measurement) !== 0) {
      urlString += `&m${idx}=${value.measurement}&l${idx}=${
        value.level
      }&g${idx}=${value.greaterThan ? 1 : 0}`;
      idx += 1;
    }
  }
  return urlString;
};
